__webpack_require__.p = "https://cdn.assembly.com/copilot/assets/";